import axios from 'axios';

import { IMerchantLocationEmployee } from '@/shared/model/merchant-location-employee.model';

const baseApiUrl = 'api/merchant-location-employees';

export default class MerchantLocationEmployeeService {
  public find(id: number): Promise<IMerchantLocationEmployee> {
    return new Promise<IMerchantLocationEmployee>(resolve => {
      axios.get(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>(resolve => {
      axios.get(baseApiUrl).then(function(res) {
        resolve(res);
      });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>(resolve => {
      axios.delete(`${baseApiUrl}/${id}`).then(function(res) {
        resolve(res);
      });
    });
  }

  public create(entity: IMerchantLocationEmployee): Promise<IMerchantLocationEmployee> {
    return new Promise<IMerchantLocationEmployee>(resolve => {
      axios.post(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }

  public update(entity: IMerchantLocationEmployee): Promise<IMerchantLocationEmployee> {
    return new Promise<IMerchantLocationEmployee>(resolve => {
      axios.put(`${baseApiUrl}`, entity).then(function(res) {
        resolve(res.data);
      });
    });
  }
}
